module.exports = __webpack_public_path__ + "img/avatar.306d94ce.svg";